<template>
  <card-dialog
    v-model="modalVisible"
    app
    right
    clipped
    max-width="1300px"
    :title="$t('card_dialog.customize_screen.title')"
  >
    <v-card-text class="pa-6">
      <performance-variable-selection
        :coach="user.coach"
        :dashboard="dashboard"
        :default-view="view"
        @input="input"
      />
    </v-card-text>
    <template v-slot:actions>
      <v-card-actions class="pa-4">
        <div class="flex-grow-1">
          <v-btn
            color="primary"
            class="text-none"
            :loading="submitting"
            @click="save"
          >
            {{ $t('button.save') }}
          </v-btn>
        </div>
      </v-card-actions>
    </template>
  </card-dialog>
</template>

<script>

import CardDialog from '@/components/helpers/CardDialog.vue'
import PerformanceVariableSelection from '@/components/performance/PerformanceVariableSelection.vue'
import { CoachApiService } from '@/data/services'

export default {
  name: 'PerformanceCoachCustomize',
  components: { PerformanceVariableSelection, CardDialog },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    dashboard: {
      type: String,
      required: true
    },
    view: {
      type: String,
      required: true
    }
  },
  data: () => ({
    selectedTeamVariables: null,
    submitting: false,
    payload: {}
  }),
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    }
  },
  created() {
  },
  methods: {
    async save() {
      this.submitting = true

      try {
        await CoachApiService.saveVariables(this.user.coach.id, {
          ...this.payload,
          dashboard: this.dashboard
        })

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.variables_save.success'),
          color: 'success'
        })

        this.modalVisible = false
        this.$emit('save')
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.variables_save.error'),
          color: 'error'
        })
      } finally {
        this.submitting = false
      }
    },
    input(data) {
      this.payload = data
    }
  }
}

</script>

<style scoped>

</style>
